<template>
  <article
    class="accruals-data-card"
    data-testid="accruals-page__data-card"
    role="button"
    tabindex="0"
    @click="$emit('open')"
    @keydown.enter="onCardKeydown"
    @keydown.space="onCardKeydown"
  >
    <header class="accruals-data-card__header">
      <div class="accruals-data-card__title-group">
        <span class="accruals-data-card__icon-wrap">
          <img :src="assets.ICON_DATABASE" alt="" class="accruals-data-card__icon" />
        </span>
        <h3 class="accruals-data-card__title">Data</h3>
      </div>
      <button
        type="button"
        class="accruals-data-card__sync"
        data-testid="accruals-page__sync-btn"
        :disabled="loading"
        @click.stop="$emit('sync')"
      >
        <span class="accruals-data-card__sync-icon-wrap">
          <img :src="assets.ICON_SYNC" alt="" class="accruals-data-card__sync-icon" />
        </span>
        <span>Sync</span>
      </button>
    </header>

    <div class="accruals-data-card__metrics">
      <button
        v-for="metric in metrics"
        :key="metric.key"
        type="button"
        class="accruals-data-card__metric"
        :data-testid="`accruals-page__metric-row--${metric.key}`"
        @click.stop="$emit('open-metric', metric.key)"
      >
        <span class="accruals-data-card__metric-value">{{ metric.value }}</span>
        <span class="accruals-data-card__metric-label">{{ metric.label }}</span>
      </button>
    </div>

    <p class="accruals-data-card__last-synced" data-testid="accruals-page__last-synced">
      Last synced<span v-if="lastSyncedLabel"> · {{ lastSyncedLabel }}</span>
    </p>
    <p
      v-if="issueLabel"
      class="accruals-data-card__issue"
      data-testid="accruals-page__ingest-issue"
    >
      {{ issueLabel }}
    </p>
  </article>
</template>

<script>
import { ACCRUALS_ASSETS } from '../accrualsPageConstants';

export default {
  name: 'AccrualsDataCard',
  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
    lastSyncedLabel: { type: String, default: '' },
    issueLabel: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      assets: ACCRUALS_ASSETS,
    };
  },
  methods: {
    onCardKeydown(event) {
      if (event.target !== event.currentTarget) return;
      event.preventDefault();
      this.$emit('open');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsDataCard.scss';
</style>
